import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import { withRouter } from "../../Helpers/withRouter";
import Tabs from "../../Components/Tabs/Tabs";
import PopularBrands from "../../Components/PopularBrands/PopularBrands";
import Bundle from "../../Components/Bundle/Bundle";
import RecentCard from "../../Components/RecentActivityCard/RecentActivityCard";
import { ACTIONS, SLIDES_TO_SHOW_DESKTOP, SLIDES_TO_SCROLL_DESKTOP, LOADING_CARDS_COUNT_DESKTOP, LOADING_CARDS_COUNT_MOBILE, SLIDES_TO_SHOW_MOBILE, SLIDES_TO_SCROLL_MOBILE, popularBrandActions, SOURCES } from "../../Constants/buyEngager";
import DependencyManager from "../../DependencyManager";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
var css = {
  "buyEngagerContainer": "oalp-2fKjv",
  "tabsContainer": "oalp-1zJ_u",
  "rangeTab": "oalp-2ppVz",
  "tabs": "oalp-1OppI",
  "contentContainer": "oalp-o2uKG",
  "bundleContainer": "oalp-2G6iN",
  "rangeContainer": "oalp-1TQI6",
  "rangeContainerBudget": "oalp-3CWhW",
  "rangeContainerBrand": "oalp-1ypvm",
  "dotsClass": "oalp-34aUX",
  "mobile": "oalp-3zOkF"
};
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
import { UNKNOWN } from "../../Constants/locations";
import { compose } from 'redux';
import { mobileBreakPointsBuyengager } from "../../Constants/bundle";
import withConfig from "../../ComponentDependency/withConfig";
export var BuyEngagerWidget = function BuyEngagerWidget(_ref) {
  var _classnames2;
  var _ref$data = _ref.data,
    _ref$data2 = _ref$data === void 0 ? {} : _ref$data,
    _ref$data2$tabsData = _ref$data2.tabsData,
    tabsData = _ref$data2$tabsData === void 0 ? [] : _ref$data2$tabsData,
    _ref$data2$defaultSel = _ref$data2.defaultSelectedTab,
    defaultSelectedTab = _ref$data2$defaultSel === void 0 ? 0 : _ref$data2$defaultSel,
    _ref$data2$category = _ref$data2.category,
    category = _ref$data2$category === void 0 ? '' : _ref$data2$category,
    _ref$data2$showTabs = _ref$data2.showTabs,
    showTabs = _ref$data2$showTabs === void 0 ? true : _ref$data2$showTabs,
    viewAll = _ref$data2.viewAll,
    source = _ref$data2.source,
    tabTextStyle = _ref$data2.tabTextStyle,
    router = _ref.router,
    track = _ref.track,
    widgetKey = _ref.widgetKey,
    locationId = _ref.locationId,
    name = _ref.name,
    browsingMode = _ref.browsingMode,
    origin = _ref.origin,
    metadata = _ref.metadata,
    templateName = _ref.templateName,
    onItemView = _ref.onItemView,
    config = _ref.config;
  var _a, _b;
  var _useState = useState(tabsData ? tabsData[defaultSelectedTab] : null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTabData = _useState2[0],
    setSelectedTabData = _useState2[1];
  var PanameraConstants = DependencyManager.getDependency('constants');
  var IS_DEKSTOP = PanameraConstants.platform === 'desktop';
  var isOlxMobbi = config === null || config === void 0 ? void 0 : config.get('isOlxMobbi');
  var nameSelectedTab = (selectedTabData === null || selectedTabData === void 0 ? void 0 : selectedTabData.key) ? (_a = selectedTabData === null || selectedTabData === void 0 ? void 0 : selectedTabData.key) === null || _a === void 0 ? void 0 : _a.split(' ').join('_').toLowerCase() : '';
  var titleSelectedTab = (_b = selectedTabData === null || selectedTabData === void 0 ? void 0 : selectedTabData.defaultTitleMessage) !== null && _b !== void 0 ? _b : '';
  var _ref2 = selectedTabData || {},
    _ref2$key = _ref2.key,
    selectedTab = _ref2$key === void 0 ? '' : _ref2$key,
    action = _ref2.action,
    _ref2$attribute = _ref2.attribute,
    attribute = _ref2$attribute === void 0 ? '' : _ref2$attribute,
    _ref2$flow = _ref2.flow,
    flow = _ref2$flow === void 0 ? '' : _ref2$flow,
    _ref2$apiUrl = _ref2.apiUrl,
    apiUrl = _ref2$apiUrl === void 0 ? '' : _ref2$apiUrl,
    _ref2$bundleType = _ref2.bundleType,
    bundleType = _ref2$bundleType === void 0 ? '' : _ref2$bundleType,
    showEmiPlaceHolder = _ref2.showEmiPlaceHolder,
    apiParams = _ref2.apiParams,
    _ref2$showAll = _ref2.showAll,
    showAll = _ref2$showAll === void 0 ? '' : _ref2$showAll,
    _ref2$trackingInfo = _ref2.trackingInfo,
    _ref2$trackingInfo2 = _ref2$trackingInfo === void 0 ? {} : _ref2$trackingInfo,
    _ref2$trackingInfo2$s = _ref2$trackingInfo2.select_from,
    select_from = _ref2$trackingInfo2$s === void 0 ? '' : _ref2$trackingInfo2$s,
    _ref2$showVasStrip = _ref2.showVasStrip,
    showVasStrip = _ref2$showVasStrip === void 0 ? true : _ref2$showVasStrip,
    showOlxAutosAdCardTag = _ref2.showOlxAutosAdCardTag,
    emptyCentreImageName = _ref2.emptyCentreImageName,
    cardsCountInEachRow = _ref2.cardsCountInEachRow,
    _ref2$withOlxAutos = _ref2.withOlxAutos,
    withOlxAutos = _ref2$withOlxAutos === void 0 ? false : _ref2$withOlxAutos,
    imageProps = _ref2.imageProps,
    showTagInFirstCard = _ref2.showTagInFirstCard,
    tagImage = _ref2.tagImage,
    _ref2$titleSection = _ref2.titleSection,
    titleSection = _ref2$titleSection === void 0 ? {
      'text': ''
    } : _ref2$titleSection;
  var onTabClick = useCallback(function (tabData) {
    var key = tabData.key,
      action = tabData.action,
      _tabData$redirectUrl = tabData.redirectUrl,
      redirectUrl = _tabData$redirectUrl === void 0 ? '' : _tabData$redirectUrl;
    var _ref3 = selectedTabData || {},
      selectedTab = _ref3.key;
    if (key !== selectedTab) {
      var chosen_option = key.split(' ').join('_').toLowerCase();
      if (track && metadata && metadata.trackingInfo && metadata.trackingInfo.clickEvent && metadata.trackingInfo.clickEvent.name) {
        var trackingEventName = metadata.trackingInfo.clickEvent.name;
        var trackingInfo = TrackingInfoManager.getTrackingInfo({
          variants_shown: widgetKey,
          browsing_location_id: locationId || UNKNOWN,
          browsing_mode: browsingMode,
          origin: origin,
          chosen_option: chosen_option,
          resultset_type: templateName,
          select_from: name
        });
        if (action === ACTIONS.REDIRECT) {
          trackingInfo.reason = chosen_option;
          trackingInfo['chosen_option'] = '';
          trackingEventName = metadata.trackingInfo.clickEventSeeMore.name;
        }
        track(trackingEventName, trackingInfo);
      }
      if (action === ACTIONS.REDIRECT) {
        setSelectedTabData(null);
        if (redirectUrl) {
          router === null || router === void 0 ? void 0 : router.push(isOlxMobbi ? "/olxmobbi".concat(redirectUrl) : redirectUrl);
        }
      } else {
        setSelectedTabData(tabData);
      }
    }
  }, [selectedTabData, track, metadata, widgetKey, locationId, browsingMode, origin, templateName, name, router]);
  var dotsClass = classnames(css.dotsClass, css[PanameraConstants.platform]);
  var mobileSettings = {
    dots: false,
    dotsClass: dotsClass,
    slidesToShow: SLIDES_TO_SHOW_MOBILE,
    slidesToScroll: SLIDES_TO_SCROLL_MOBILE,
    variableWidth: showTagInFirstCard ? true : false
  };
  var desktopSettings = {
    dots: true,
    dotsClass: dotsClass,
    slidesToShow: SLIDES_TO_SHOW_DESKTOP,
    slidesToScroll: SLIDES_TO_SCROLL_DESKTOP
  };
  var settings = IS_DEKSTOP ? desktopSettings : mobileSettings;
  return /*#__PURE__*/React.createElement("div", {
    className: css.buyEngagerContainer
  }, showTabs && /*#__PURE__*/React.createElement("div", {
    className: classnames(css.tabsContainer, _defineProperty({}, css.rangeTab, source === SOURCES.HOME_PAGE_FILTER))
  }, /*#__PURE__*/React.createElement(Tabs, {
    selectedTab: selectedTab,
    onTabClick: onTabClick,
    tabsData: tabsData,
    tabsClassName: css.tabs,
    tabTextStyle: tabTextStyle,
    "data-aut-id": "tabs"
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(css.contentContainer, (_classnames2 = {}, _defineProperty(_classnames2, css.bundleContainer, action === ACTIONS.SHOW_BUNDLES || action === ACTIONS.RECENT_ACTIVITY), _defineProperty(_classnames2, css.rangeContainer, source === SOURCES.HOME_PAGE_FILTER), _defineProperty(_classnames2, css.rangeContainerBudget, source === SOURCES.HOME_PAGE_FILTER_BUDGET), _defineProperty(_classnames2, css.rangeContainerBrand, source === SOURCES.HOME_PAGE_FILTER_BRAND), _classnames2))
  }, action === ACTIONS.SHOW_BUNDLES && /*#__PURE__*/React.createElement(Bundle, {
    sliderSettings: settings,
    url: apiUrl,
    apiParams: apiParams,
    bundleType: 'RECENT',
    showEmiPlaceHolder: showEmiPlaceHolder,
    count: IS_DEKSTOP ? LOADING_CARDS_COUNT_DESKTOP : LOADING_CARDS_COUNT_MOBILE,
    showAllUrl: showAll,
    source: 'buyEngager',
    selectFrom: select_from,
    hideShowAllLink: true,
    widgetKey: name,
    track: track,
    metadata: metadata,
    templateName: templateName,
    name: nameSelectedTab,
    onItemView: onItemView,
    showVasStrip: showVasStrip,
    showOlxAutosAdCardTag: showOlxAutosAdCardTag,
    emptyCentreImageName: emptyCentreImageName,
    responsiveBreakpoints: mobileBreakPointsBuyengager,
    showTagInFirstCard: showTagInFirstCard,
    tagImage: tagImage,
    titleSection: titleSection,
    selectedTab: titleSelectedTab
  }), action && popularBrandActions.includes(action) && /*#__PURE__*/React.createElement(PopularBrands, {
    isDesktop: IS_DEKSTOP,
    attribute: attribute,
    flow: flow,
    category: category,
    viewAll: viewAll,
    source: source || '',
    trackingInfo: metadata === null || metadata === void 0 ? void 0 : metadata.trackingInfo,
    name: name,
    browsingMode: browsingMode,
    origin: origin,
    track: track,
    locationId: locationId,
    action: action,
    selectFrom: select_from,
    cardsCountInEachRow: cardsCountInEachRow,
    withOlxAutos: withOlxAutos,
    imageProps: imageProps,
    config: config
  }), action === ACTIONS.RECENT_ACTIVITY && /*#__PURE__*/React.createElement(RecentCard, {
    sliderSettings: settings,
    url: apiUrl,
    apiParams: apiParams,
    bundleType: bundleType,
    showEmiPlaceHolder: showEmiPlaceHolder,
    count: IS_DEKSTOP ? LOADING_CARDS_COUNT_DESKTOP : LOADING_CARDS_COUNT_MOBILE,
    showAllUrl: showAll,
    source: 'buyEngager',
    selectFrom: select_from,
    hideShowAllLink: true,
    widgetKey: name,
    track: track,
    metadata: metadata,
    templateName: templateName,
    name: selectedTabData ? selectedTabData.key.split(' ').join('_').toLowerCase() : '',
    onItemView: onItemView,
    showVasStrip: showVasStrip,
    showOlxAutosAdCardTag: showOlxAutosAdCardTag,
    emptyCentreImageName: emptyCentreImageName,
    responsiveBreakpoints: mobileBreakPointsBuyengager
  })));
};
export default compose(withComponentDependency, withConfig, withRouter)(BuyEngagerWidget);